export default __webpack_public_path__ + "static/media/about_me.d0c9360d.svg";